import type { CityConfig } from "@/pages/city-template/types";

export const gettysburgConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Gettysburg",
  state: "Pennsylvania",
  stateAbbr: "PA",
  slug: "gettysburg",
  route: "/cities/gettysburg",
  title: "Emergency Passport Gettysburg, PA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Gettysburg, PA — as fast as 24 hours. Same-day courier processing for Adams County residents, Gettysburg College students, and South Central Pennsylvania travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Gettysburg, Pennsylvania",
  heroSubtitle: "Gettysburg College student heading abroad for a battlefield history program in Europe? Family vacation to Canada and your passport expired? Fast Passport Center helps Gettysburg and Adams County residents get their passports fast — as fast as 24 hours. A+ BBB rated. No office visit required for most services.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Gettysburg%20Pennsylvania%20historic%20downtown%20Lincoln%20Square%20with%20classic%20brick%20buildings%20and%20the%20historic%20Gettysburg%20Hotel%2C%20charming%20small%20town%20streets%20with%20American%20flags%20and%20period%20architecture%2C%20Gettysburg%20National%20Military%20Park%20landscape%20with%20rolling%20green%20hills%20and%20split-rail%20fences%20in%20distance%2C%20warm%20autumn%20afternoon%20light%20with%20golden%20tones%2C%20photorealistic%20town%20photography%20capturing%20historic%20character%2C%20no%20readable%20text%20or%20signs&width=1800&height=700&seq=gettysburg-hero-01&orientation=landscape",
  heroImageAlt: "Gettysburg Pennsylvania historic downtown Lincoln Square with classic architecture",
  geoPosition: "39.8309;-77.2311",
  geoPlacename: "Gettysburg, Pennsylvania",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Philadelphia Passport Agency",
    address: "200 Chestnut St, Philadelphia, PA 19106",
    distance: "About 140 miles east — 2.5 hours by car",
  },
  nearbyCitiesZips: [
    { name: "Gettysburg", zips: "17325" },
    { name: "Hanover", zips: "17331" },
    { name: "Littlestown", zips: "17340" },
    { name: "Fairfield", zips: "17320" },
    { name: "Biglerville", zips: "17307" },
    { name: "New Oxford", zips: "17350" },
    { name: "McSherrystown", zips: "17344" },
    { name: "Abbottstown", zips: "17301" },
    { name: "East Berlin", zips: "17316" },
    { name: "Orrtanna", zips: "17353" },
    { name: "Cashtown", zips: "17310" },
    { name: "Arendtsville", zips: "17303" },
  ],
  benefits: [
    { icon: "ri-computer-line", title: "Start 100% Online", desc: "No office visit required to begin. Complete your order from home in Gettysburg or your dorm at Gettysburg College in minutes." },
    { icon: "ri-truck-line", title: "Ship Overnight from Adams County", desc: "FedEx and UPS locations throughout Gettysburg and the Adams County area offer overnight shipping to our processing center." },
    { icon: "ri-shield-check-line", title: "Expert Document Review", desc: "Every application is reviewed by our team before submission — critical for Gettysburg College students with study abroad deadlines." },
    { icon: "ri-calendar-check-line", title: "Reserved Agency Access", desc: "We hold reserved submission slots at the Philadelphia Passport Agency — no public appointment hunting needed." },
  ],
  testimonials: [
    {
      name: "Emily H.",
      location: "Gettysburg, PA",
      rating: 5,
      text: "I'm a Gettysburg College junior who got accepted to a summer program in Florence with only 3 weeks to get a passport. Fast Passport Center got my first passport processed in 8 days. The checklist was so clear and easy to follow.",
      service: "New Passport",
    },
    {
      name: "William B.",
      location: "Hanover, PA",
      rating: 5,
      text: "We planned a family trip to Ireland to trace our ancestry and realized my wife's passport had expired. Fast Passport Center renewed it in 6 days. We shipped from the UPS in Gettysburg and had it back before our flight from BWI.",
      service: "Passport Renewal",
    },
    {
      name: "Margaret D.",
      location: "Biglerville, PA",
      rating: 5,
      text: "Needed passports for my two kids for a cruise leaving from Baltimore. Fast Passport Center made the child passport process straightforward. Both arrived in 9 days. Excellent communication throughout.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "gettysburg-post",
      name: "Gettysburg Post Office",
      type: "USPS Passport Acceptance",
      address: "115 Buford Ave",
      city: "Gettysburg",
      state: "PA",
      zip: "17325",
      phone: "800-275-8777",
      hours: "Mon–Fri 8:30am–5pm",
      distance: "Downtown Gettysburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Primary passport acceptance location in Gettysburg. Appointment required — book online. Photo services available on-site.",
      icon: "ri-mail-line",
    },
    {
      id: "adams-county-courthouse",
      name: "Adams County Courthouse",
      type: "County Passport Acceptance",
      address: "111 Baltimore St",
      city: "Gettysburg",
      state: "PA",
      zip: "17325",
      phone: "717-337-9800",
      hours: "Mon–Fri 8:30am–4:30pm",
      distance: "Downtown Gettysburg",
      website: "https://www.adamscounty.us/",
      websiteLabel: "Adams County Website",
      notes: "Adams County courthouse passport acceptance. Call ahead to confirm hours and appointment requirements.",
      icon: "ri-government-line",
    },
    {
      id: "hanover-post",
      name: "Hanover Post Office",
      type: "USPS Passport Acceptance",
      address: "18 High St",
      city: "Hanover",
      state: "PA",
      zip: "17331",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4:30pm",
      distance: "Hanover — about 12 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Hanover option for eastern Adams County and York County border residents.",
      icon: "ri-mail-line",
    },
    {
      id: "littlestown-post",
      name: "Littlestown Post Office",
      type: "USPS Passport Acceptance",
      address: "2 S Queen St",
      city: "Littlestown",
      state: "PA",
      zip: "17340",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4pm",
      distance: "Littlestown — about 9 miles southeast",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Littlestown option for southern Adams County residents near the Maryland border.",
      icon: "ri-mail-line",
    },
  ],
  faqs: [
    {
      q: "Can I get an emergency passport in Gettysburg before international travel?",
      a: "Yes. Through Fast Passport Center, Gettysburg travelers can get an expedited passport in as little as 2–9 business days, and emergency processing is available in as fast as 24 hours depending on your eligibility. Start your order online today.",
    },
    {
      q: "How fast can I renew my passport in Gettysburg?",
      a: "Fast passport renewal in Gettysburg is available through Fast Passport Center in as little as 3 business days with our expedited service, or 3–5 weeks with our standard expedited option. Most renewals require no office visit.",
    },
    {
      q: "Can Gettysburg College students get expedited passports for study abroad?",
      a: "Absolutely. We help Gettysburg College students get passports fast for study abroad programs — including popular history, political science, and language immersion programs in Europe. Start early — we can meet tight semester deadlines.",
    },
    {
      q: "Does Gettysburg have a regional passport agency?",
      a: "Gettysburg does not have a regional passport agency. The closest are the Philadelphia Passport Agency (about 140 miles east) and the Washington DC Passport Agency (about 85 miles south). Both require appointments and proof of travel within 14 days. Fast Passport Center is the faster, more convenient solution.",
    },
    {
      q: "Can I expedite a child passport in Gettysburg?",
      a: "Yes. Child passport expediting in Gettysburg is possible through Fast Passport Center. Child passports for minors 15 and under require an in-person acceptance step with parental consent. We provide a clear checklist and handle expedited processing after the acceptance step.",
    },
    {
      q: "What airports do Gettysburg travelers typically use?",
      a: "Harrisburg International Airport (MDT — about 45 miles northeast), Baltimore-Washington International (BWI — about 65 miles south), and Washington Dulles (IAD — about 80 miles south) are the primary airports for Gettysburg travelers. All offer domestic connections and international departures.",
    },
    {
      q: "How long does a standard passport take in Gettysburg?",
      a: "If you apply through a standard post office acceptance facility in Gettysburg, processing times run 6–13 weeks — sometimes longer during peak travel season. If your travel is sooner, you need expedited processing through Fast Passport Center.",
    },
    {
      q: "Can I get a passport renewal in Gettysburg without visiting an office?",
      a: "Yes. Most Gettysburg-area adults renewing a passport can do so entirely by mail. Start your order online, complete documents at home, and ship overnight from any FedEx or UPS in Gettysburg or the Adams County area.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Gettysburg", address: "1010 York Rd, Gettysburg, PA 17325", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/" },
    { name: "CVS — Gettysburg", address: "11-15 York St, Gettysburg, PA 17325", hours: "Mon–Sat 7 AM – 10 PM, Sun 8 AM – 8 PM", website: "https://www.cvs.com/" },
    { name: "Walmart — Gettysburg", address: "1270 York Rd, Gettysburg, PA 17325", hours: "Daily 6 AM – 11 PM", website: "https://www.walmart.com/" },
    { name: "The UPS Store — Gettysburg", address: "231 W High St, Gettysburg, PA 17325", hours: "Mon–Fri 8 AM – 6 PM, Sat 9 AM – 2 PM", website: "https://www.theupsstore.com/" },
    { name: "Walgreens — Hanover", address: "101 Carlisle St, Hanover, PA 17331", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/" },
  ],
  dmvLocations: [
    {
      name: "Gettysburg PennDOT Driver License Center",
      address: "63 N 4th St, Gettysburg, PA 17325",
      hours: "Tue–Sat 8:30 AM – 4:15 PM",
      note: "Gettysburg PennDOT center. Driver licenses, REAL ID, ID cards. Appointment recommended.",
      featured: true,
    },
    {
      name: "Hanover PennDOT Driver License Center",
      address: "1180 Carlisle St, Hanover, PA 17331",
      hours: "Tue–Sat 8:30 AM – 4:15 PM",
      note: "Hanover PennDOT option for eastern Adams County and York County residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MDT",
      name: "Harrisburg International Airport",
      distance: "About 45 miles northeast — 50 minutes drive",
      address: "1 Terminal Dr, Middletown, PA 17057",
      note: "MDT is the closest commercial airport for Gettysburg travelers, offering connections to major hubs for international travel.",
      flightUrl: "https://www.flyhia.com/",
      flightLabel: "MDT Airport Website",
      featured: true,
    },
    {
      code: "BWI",
      name: "Baltimore-Washington International Airport",
      distance: "About 65 miles south — 1.25 hours drive",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "BWI offers extensive domestic and international flights including direct service to Europe and the Caribbean. A popular choice for Gettysburg travelers.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Airport Website",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Flying from BWI or MDT in 24–72 hours? Our emergency courier service is designed for urgent, last-minute travel from Gettysburg and South Central Pennsylvania.",
      bullets: ["As fast as 24 hours", "Reserved agency submission slots", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already have a U.S. passport? We help Gettysburg and Adams County travelers renew fast — no office visit required for most renewals.",
      bullets: ["Eligible for expedited processing", "Ship from any FedEx or UPS in Gettysburg", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost Passport Replacement",
      description: "Lost your passport before a trip? We guide Gettysburg travelers through Form DS-64 and the replacement process — urgent timelines available.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Child passport expedited service for Gettysburg families — minors under 16 require in-person acceptance and parental consent.",
      bullets: ["Both parents must typically consent", "Clear checklist provided", "Expedited options after acceptance step"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Gettysburg residents and Gettysburg College students heading abroad.",
      bullets: ["Step-by-step checklist", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-truck-line",
      title: "Passport Courier Service",
      description: "Fast Passport Center is a registered U.S. Department of State courier — we submit through reserved agency channels, not public lines.",
      bullets: ["State Dept. registered courier", "Reserved daily submission slots", "Not affected by government shutdowns"],
      badge: "Registered Courier",
      link: "https://fastpassportcenter.com/checkout/",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change & Other Services",
      description: "Passport name changes after marriage or divorce, damaged passport replacement, second passports for frequent travelers — all expedited.",
      bullets: ["Name change after marriage/divorce", "Damaged passport replacement", "Second passport for frequent travel"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Gettysburg, Pennsylvania travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Expedited Passport", description: "Expedited passport processing for Gettysburg and Adams County residents needing passports faster than standard government mail timelines." },
    { name: "Passport Renewal", description: "Fast passport renewal for Gettysburg, PA residents with a passport issued within the last 15 years at age 16 or older." },
    { name: "Lost Passport Replacement", description: "Emergency passport replacement service for Gettysburg travelers with lost or stolen passports." },
    { name: "Child Passport", description: "Expedited child passport services for Gettysburg families with minors under 16." },
    { name: "Passport Courier Service", description: "Registered U.S. Department of State courier passport submission service serving Gettysburg, Pennsylvania." },
  ],
  mistakes: [
    { icon: "ri-time-line", title: "Waiting Too Long to Apply", description: "Gettysburg travelers often underestimate processing times. Government processing runs 6–13 weeks — longer during summer tourist season. Apply as soon as you book your trip." },
    { icon: "ri-camera-off-line", title: "Wrong Passport Photo", description: "Photos from drugstores and photo booths often get rejected for lighting, background, or expression issues. We provide exact specs and catch these issues before submission." },
    { icon: "ri-file-damage-line", title: "Incomplete or Incorrect Forms", description: "One wrong date, one missing signature — your application gets sent back and you lose weeks. Our checklist catches errors before submission." },
    { icon: "ri-pen-nib-line", title: "Wrong Birth Certificate Type", description: "Not all birth certificates are accepted. Some require a long-form certified copy with a raised seal. We tell you exactly what you need." },
    { icon: "ri-calendar-close-line", title: "Assuming the Post Office is Fast Enough", description: "Standard USPS passport processing out of Gettysburg runs 6–13 weeks. If your trip is in under 10 weeks, standard processing is a gamble. Use our courier service instead." },
    { icon: "ri-map-pin-time-line", title: "Name Mismatch Across Documents", description: "Your passport name must match your airline ticket exactly. Middle names and suffixes cause more rejections than you'd expect." },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose your processing speed based on your Gettysburg travel date. Complete your secure order online — takes just a few minutes." },
    { number: "02", icon: "ri-file-list-3-line", title: "Receive Your Personalized Checklist", description: "We confirm your details and send you a personalized document checklist — exactly what you need." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Documents Overnight from Gettysburg", description: "Drop off at any FedEx or UPS in Gettysburg or the Adams County area. Most locations are open evenings." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit your application through our reserved passport agency slots — bypassing the public appointment system." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport is Completed", description: "Your passport is completed within the timeframe you selected and shipped back to you. No guessing, no hoping." },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned", "Daily status updates", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "Must travel to Philadelphia or DC", "Expect to wait all day"],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — limited slots, often weeks out in Philadelphia or DC", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Must drive to Philadelphia (2.5 hours) or DC (1.5 hours)", fpc: "Ship documents overnight from Gettysburg" },
    { feature: "Processing Speed", agency: "Urgent travel only — strict eligibility", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection", fpc: "Professional review included" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission slots" },
    { feature: "Door-to-Door", agency: "You drive 2.5 hours and wait all day", fpc: "Ship from local FedEx/UPS — we handle the rest" },
    { feature: "Predictability", agency: "Appointments can be cancelled", fpc: "Predictable processing based on option" },
    { feature: "Government Shutdowns", agency: "Operations may be impacted", fpc: "Not affected by government shutdowns" },
    { feature: "Success Rate", agency: "Depends on appointment availability", fpc: "99%+ application approval rate" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Acceptance Locations", href: "#acceptance-facilities" },
    { label: "vs. Regional Agency", href: "#comparison" },
    { label: "FAQ", href: "#faq" },
    { label: "Local Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Hanover", route: "/cities/hanover" },
    { name: "Fast passport renewal near Harrisburg", route: "/cities/harrisburg-pa" },
    { name: "Emergency passport help for Adams County travelers", route: "/states/pennsylvania" },
    { name: "Rush passport service in York", route: "/cities/york-pa" },
  ],
  fpcOfficeNote: "After signing up online, we send your personalized checklist and shipping instructions. Ship your documents overnight from any FedEx or UPS location in Gettysburg or the Adams County area — most are open evenings. No office visit to our facility required for most services.",
  fpcOfficeDistance: "Serving Gettysburg and all of Adams County remotely",
  serviceAreaIntro: "Whether you are in historic Gettysburg, Hanover, Littlestown, Fairfield, or anywhere in Adams County, Fast Passport Center makes expedited passport processing simple — start online, ship overnight, and we handle the rest.",
  nearbyCitiesIntro: "We serve all Gettysburg and Adams County zip codes. Anywhere in South Central Pennsylvania — ship overnight and your documents are at our processing center the next morning.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Gettysburg as simple as possible. Most Gettysburg clients never visit an office.",
  mistakesIntro: "These mistakes cause the most delays and rejections for Gettysburg travelers. Fast Passport Center reviews your documents before submission to catch these issues.",
  testimonialsIntro: "Real reviews from Gettysburg, Hanover, and Biglerville travelers who needed their passports fast and trusted Fast Passport Center.",
  faqIntro: "The most common questions Gettysburg and Adams County travelers ask about emergency and expedited passport services.",
  statePageRoute: "/states/pennsylvania",
  statePageName: "Pennsylvania",
  dmvWebsite: "https://www.dmv.pa.gov/",
  dmvLabel: "PennDOT — Official Website",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from Pennsylvania Department of Health Vital Records for Adams County.", url: "https://www.health.pa.gov/topics/certificates/Pages/Birth-Certificates.aspx" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through Pennsylvania Department of Health Vital Records.", url: "https://www.health.pa.gov/topics/certificates/Pages/Death-Certificates.aspx" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Adams County Register of Wills.", url: "https://www.adamscounty.us/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through Adams County Prothonotary.", url: "https://www.adamscounty.us/" },
    { icon: "ri-global-line", label: "VitalChek", desc: "Order Pennsylvania birth, death, marriage, and divorce certificates online through VitalChek for convenience.", url: "https://www.vitalchek.com/" },
  ],
};